// extracted by mini-css-extract-plugin
module.exports = {"Story":"Story_Story__1o-zh","Story-citation":"Story_Story-citation__xIbWZ","Story-title":"Story_Story-title__3O-cs","btn":"Story_btn__2AqUA"};